import type { SuggestionStatus } from './types';

/**
 * Copy for the "already suggested" notice, chosen from the duplicate's own
 * status. Only a `public` row is votable, so only that one may promise a vote.
 */
export function duplicateNoticeKey(status: SuggestionStatus): string {
  switch (status) {
    case 'public':
      return 'templateIdeas.duplicate.notice';
    case 'promoted':
      return 'templateIdeas.duplicate.noticePromoted';
    case 'rejected':
      return 'templateIdeas.duplicate.noticeRejected';
    case 'pending':
    default:
      return 'templateIdeas.duplicate.noticePending';
  }
}

/**
 * The scroll-to-the-card action only makes sense for a row that is actually in
 * the public ranking; every other status has no card on the page to reach.
 */
export function canViewDuplicateInRanking(status: SuggestionStatus): boolean {
  return status === 'public';
}
